import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentAccountPrlObj} from '../../../../../generated/generated.model';
import {KeyValueObj} from 'mx-core';

const PAYMENT_ACCOUNTS_REST_URL: string = '/rest/payment-accounts';

@Injectable({
    providedIn: 'root'
})
export class PrlPaymentAccountsService {

    private paymentAccounts: Array<PaymentAccountPrlObj> = [];
    private paymentAccountsForCombobox: Array<KeyValueObj> = [];

    constructor(
        private httpClient: HttpClient
    ) {
    }

    public getPaymentAccounts = (): Array<PaymentAccountPrlObj> => {
        return this.paymentAccounts;
    };

    public setPaymentAccounts = (array: Array<PaymentAccountPrlObj>) => {
        this.paymentAccounts = array;
    };

    public getPaymentAccountsFromDB(): Observable<Array<PaymentAccountPrlObj>> {
        return this.httpClient.get<Array<PaymentAccountPrlObj>>(PAYMENT_ACCOUNTS_REST_URL);
    };
}

